<template>
  <fin-score :value="value"
             data-key="finScore"
             :size="size"/>
</template>

<script>
import FinScore from "@/components/common/score"

export default {
  name: "RankingCell",
  components: {FinScore},
  props: {
    value: {},
    header: {}
  },
  computed:{
    componentProps() {
      return this.header.componentProps
    },
    size() {
      return this.componentProps?.size || (this.$vuetify.breakpoint.xsOnly ? 30 : 33)
    }
  }
}
</script>

<style scoped>

</style>
